import { CSSObject } from '@chakra-ui/react';

export const BoxResultedWrapper: CSSObject = {
  mb: '0',
  px: '2',
  bg: 'rgba(78, 178, 255, 0.14)',
  borderRadius: 'md',
  flex: '1',
  boxShadow:
    '0px 4px 10px 0px rgba(0, 0, 0, 0.3), 0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset',
};

export const RaceResultsHeader: CSSObject = {
  color: 'white',
  fontSize: 'sm',
  fontFamily: 'accent',
  textTransform: 'uppercase',
  fontWeight: 'normal',
};

export const RunnerResultRow: CSSObject = {
  borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
  py: '1.5',
  h: '12',
  _last: {
    borderBottom: 'none',
  },
};

export const RunnerDetails: CSSObject = {
  gap: '2',
};

export const RunnerPlace: CSSObject = {
  borderRadius: 'base',
  bgGradient: 'linear(to-b, alpha.100, alpha.500)',
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  color: 'beta.600',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.5)',
  textTransform: 'uppercase',
  padding: '2',
  fontSize: '2xs',
  '&&': {
    h: '7',
    w: '9',
  },
  border: 'none',
};

export const RunnerNumber: CSSObject = {
  fontWeight: 'normal',
  fontSize: '2xs',
  color: 'white',
  pos: 'relative',
  bottom: '2px',
};

export const RunnerOddsContainer: CSSObject = {
  gap: '1',
};

export const RunnerOdds: CSSObject = {
  w: '12',
  h: '9',
  bg: 'blackAlpha.400',
  border: 'none',
  borderRadius: 'md',
  color: 'gamma.300',
  textShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
  fontWeight: 'normal',
  fontFamily: 'accent',
  fontSize: 'sm',
};

export const Heading: CSSObject = {
  textTransform: 'capitalize',
  color: 'gray.700',
  fontSize: 'xs',
  fontWeight: 'medium',
  py: '2',
  alignItems: 'center',
  borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
};

export const WinPlaceHeader: CSSObject = {
  py: '0',
  w: '12',
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const FlexEventRule: CSSObject = {
  pt: '2',
  color: 'white',
};
